import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import buildingsData from "../../data/buildings.json";
import "./SalesSections.css";
import FadeUp from "../FadeUp/FadeUp";

const SalesSections = ({ isAlbanian, buildingId }) => {
  const [building, setBuilding] = useState(null);

  useEffect(() => {
    if (!buildingId) return;
    const foundBuilding = buildingsData.find(
      (b) => String(b.building_id) === String(buildingId)
    );

    if (foundBuilding) {
      setBuilding(foundBuilding);
    } else {
      console.error(`Building with id ${buildingId} not found`);
    }
  }, [buildingId]);

  return (
    <div>
      <div className="salessections-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="salessections-title">
            {/* {isAlbanian ? 'Zgjidh' : 'Choose'} */}
          </div>
          <div className="bottom-line"></div>
        </div>
        <div className="salessections-grid">
          {/* Apartments Category */}
          {building && building.building_apartment_image_url && (
            <FadeUp key={building.buildingId}>
              <Link
                className="salessections-card"
                to={`/salescatalogdetails/${buildingId}/1`}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    window.location.href = `/salescatalogdetails/${buildingId}/1`;
                  }
                }}
              >
                <div className="salessections-image-square">
                  <img
                    src={building.building_apartment_image_url}
                    alt="Apartments"
                    className="salessections-image"
                    loading="lazy"
                  />
                </div>
                <div className="salessections-content">
                  <h3 className="salessectionscard-title">
                    {isAlbanian ? "APARTAMENT" : "APARTMENT"}
                  </h3>
                </div>
              </Link>
            </FadeUp>
          )}

          {/* Service Unit Category */}
          {building && building.building_service_image_url && (
            <FadeUp key={building.buildingId}>
              <Link
                className="salessections-card"
                to={`/salescatalogdetails/${buildingId}/2`}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    window.location.href = `/salescatalogdetails/${buildingId}/2`;
                  }
                }}
              >
                <div className="salessections-image-square">
                  <img
                    src={building.building_service_image_url}
                    alt="Service Unit"
                    className="salessections-image"
                    loading="lazy"
                  />
                </div>
                <div className="salessections-content">
                  <h3 className="salessectionscard-title">
                    {isAlbanian ? "NJËSI SHËRBIMI" : "SERVICE UNIT"}
                  </h3>
                </div>
              </Link>
            </FadeUp>
          )}

          {/* Car Post Category */}
          {building && building.building_post_image_url && (
            <FadeUp key={building.buildingId}>
              <Link
                className="salessections-card"
                to={`/salescatalogdetails/${buildingId}/3`}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    window.location.href = `/salescatalogdetails/${buildingId}/3`;
                  }
                }}
              >
                <div className="salessections-image-square">
                  <img
                    src={building.building_post_image_url}
                    alt="Car Post"
                    className="salessections-image"
                    loading="lazy"
                  />
                </div>
                <div className="salessections-content">
                  <h3 className="salessectionscard-title">
                    {isAlbanian ? "NJËSI PARKIMI" : "CAR POST"}
                  </h3>
                </div>
              </Link>
            </FadeUp>
          )}

          {/* Existing Category (Last One) */}
          {building && building.building_google_adress_image_url &&
            building.building_google_link && (
              <FadeUp key={building.buildingId}>
                <div className="salessections-card">
                  <a
                    href={building.building_google_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="salessections-image-square"
                  >
                    <img
                      src={building.building_google_adress_image_url}
                      alt="Building Location"
                      className="salessections-image"
                      loading="lazy"
                    />
                  </a>
                  <div className="salessections-content">
                    <h3 className="salessectionscard-title">
                      {isAlbanian ? "SHIKO VENDNDODHJEN" : "VIEW LOCATION"}
                    </h3>
                  </div>
                </div>
              </FadeUp>
            )}
        </div>
      </div>
    </div>
  );
};

export default SalesSections;
